import styled, { css } from 'styled-components';
import { Colors } from '~/config/Colors';

export const InputText = styled.div`
  width: 100%;

  ${props =>
    props.readOnly &&
    css`
      ${Label} {
        opacity: 0.5;
      }
    `}
  ${props =>
    props.disabled &&
    css`
      ${Label} {
        opacity: 0.5;
        cursor: not-allowed;
      }
    `}
`;

export const Label = styled.label`
  margin-bottom: 4px;

  color: ${Colors.text_Color_1};
  font-size: 0.75em;
  font-weight: 500;
  line-height: 10px;
`;

export const InputContainer = styled.div`
  position: relative;
`;

export const Input = styled.input`
  width: 100%;
  height: 36px;
  padding: 18px;
  border: 1px solid rgb(255 255 255 / 0.15);
  border-radius: 8px;

  color: ${Colors.text_Color_1};
  font-size: 0.75em;
  font-weight: 300;

  background: ${Colors.Input_Color_1};
  /* background: ${Colors.Color23}; */
  /* outline: none; */

  transition-timing-function: ease-in-out;
  transition-duration: 300ms;
  transition-property: border;

  /* &:valid:not([value='']) {
    border: 1px solid green;
  }

  &:invalid:not([value='']) {
    border: 1px solid red;
  } */

  &:read-only {
    background-color: ${localStorage.getItem('tema') === 'E' ? Colors.Input_Color_1 : ''};
    opacity: 0.5;
  }

  &::placeholder {
    color: ${localStorage.getItem('tema') === 'E' ? '' : Colors.text_Color_1};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    margin: 0;
    appearance: none;
  }
`;

export const Error = styled.p`
  /* display: none; */
  display: block;

  margin-top: 0.3rem;

  color: ${Colors.ftColor6};
  font-size: 0.7em;
  font-weight: 300;
  /* line-height: 100%; */

  transition-timing-function: ease-in-out;
  transition-duration: 300ms;
  transition-property: opacity;

  /* ${Input}:invalid:not([value='']) ~ & {
    display: block;
  } */
`;
